import React from "react";
// Material UI
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";

// Component
import { SIDEBAR_LINKS } from "shared/constants";
import transparentLogo from 'assets/svg/transparent_logo.svg';
import MenuIcon from "assets/svg/sidebar/menu.svg";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ClearIcon from '@material-ui/icons/Clear';
import ListLink from "./ListLink";
import Colors from "shared/color";
import { DrawerSize } from "shared/constants";
import WithQueryParams from "components/hoc/WithQueryParams";
import { Divider, Grid, IconButton } from '@material-ui/core';
import { Typography } from '@material-ui/core';

// Sidebar width
const drawerWidth = 250;

// Custom style hook
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& ::-webkit-scrollbar": {
      display: "none",
    },
  },

  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: DrawerSize["width"],
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    backgroundColor: Colors["drawerColor"],
    width: DrawerSize["width"],
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: Colors["drawerColor"],
    overflowX: "hidden",
    width: `${DrawerSize["closeWidth"]}px`,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),

    ...theme.mixins.toolbar,
  },
  content: {
    width: "81vw",
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  listHover: {
    "&:hover": {
      backgroundColor: "#32374a",
    },
  },
  bgMain: {
    backgroundColor: "#2e3345",
  },
  KsIcon:{
    "& .MuiIconButton-colorPrimary":{
      color:'#fff'
    }
  }
  
}));

const SideBar = (props) => {
  const { Allowed_Routes } = props;

  let SideBarIcons = SIDEBAR_LINKS.filter((sidebar) => {
    let found = Allowed_Routes.find((value) => value.route === sidebar.route);
    if (found) return true;
    return false;
  });

  const { children, location } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [openMobileDrawer, setMobileDrawer] = React.useState(false);

  var subListItem = null;
  if (location.pathname.split("/").length > 2) {
    let rootRoute = location.pathname.split("/")[1];
    let subItem = SIDEBAR_LINKS.find((route, index) => {
      return route.link === `/${rootRoute}`;
    });
    subListItem = !!subItem && subItem.child;
  }

  const [listActiveItem, setListActiveItem] = React.useState(subListItem);


  const handleDrawerClose = () => {
    setOpen(false);
  };
  let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))  : "";

  const renderClearIcon = () => {
    if (!listActiveItem) {
      return (
        <div className="clear_icon">
          <div>
            <img alt="Rufilo Logo" src={transparentLogo} className="logo_style" />
          </div>
          <ClearIcon onClick={e => setMobileDrawer(!openMobileDrawer)} style={{ color: '#fff' }} />
        </div>
      );
    } else {
      return null;
    }
  };
  
  return (
    <div className={classes.root}>
    <div className= {openMobileDrawer ? "mobile_drawer_open" : "web_drawer" }>
      <Drawer
        anchor="left"
        color="primary"
        variant="permanent"
        className={`${clsx(classes.drawer, {
          [classes.drawerOpen] : open ,
          [classes.drawerClose]: !open,
        })} ${open ? 'scrollbar_open' : 'scrollbar_closed' } sidebarScrollHide `}
        classes={{ 
          paper:clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div
          className={`${classes.toolbar} flex items-center cursor-pointer justify-center text-white logo_style_main`}
        >
          {open ? (
            <Grid container direction="row">
              <Grid item xs={9}>
                <img alt="Rufilo Logo" src={transparentLogo} className="logo_style" />
              </Grid>
              <Grid item xs={3} style={{textAlign:"center"}} className={classes.KsIcon}>
              <IconButton onClick={handleDrawerClose}  color="primary"  aria-label="upload picture" component="span">
                  <ChevronLeftIcon fontSize="large" />
                </IconButton>
              </Grid>
            </Grid>

          ) : (
            <img
              src={MenuIcon} 
              alt="Menu Icon"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(true);
              }}
            />
          )}
        </div>

        <List>
          {SideBarIcons.map(({ text, link, child, icon }, index) => {
              const roleRef = user?.role_reference_number;
              const isFinancier =
              roleRef === process.env.REACT_APP_FINANCIER_ARNOLD_ROLE_REFERENEC_NUMBER ||
              roleRef === process.env.REACT_APP_FINANCIER_WAYDELTA_ROLE_REFERENEC_NUMBER ||
              roleRef === process.env.REACT_APP_FINANCIER_PURPLE_ROLE_REFERENEC_NUMBER ||
              roleRef === process.env.REACT_APP_FINANCIER_PLEBGRAPH_ROLE_REFERENEC_NUMBER;

              if(isFinancier){
              if(link === "/transactions" || link === "/financier_approval"){
                return (
                  <ListLink
                    className={classes.listHover}
                    text={text}
                    key={index}
                    link={link}
                    child={child}
                    icon={icon}
                    open={open}
                    setListActiveItem={setListActiveItem}
                  />
                );
              }
            }
            else{
              return (
                <ListLink
                  className={classes.listHover}
                  text={text}
                  key={index}
                  link={link}
                  child={child}
                  icon={icon}
                  open={open}
                  setListActiveItem={setListActiveItem}
                />
              );
            }
          })}
        </List>
      </Drawer>
      
      {/* drawer with submenu */}
      <Drawer
        variant="persistent"
        style={{ backgroundColor: "#2e3345" }}
        classes={{
          paperAnchorLeft: classes.bgMain,
        }}
        open={
          listActiveItem && typeof listActiveItem === "object" ? true : false
        }
        className="_for_mobile"
        onClose={(_) => setListActiveItem(null)}
      >
        <div
          className={`${classes.drawer} ${classes.drawerOpen}`}
          style={{ width: drawerWidth - 2 }}
        >
          {Array.isArray(listActiveItem) && (
            <>
              <div
                className={`${classes.toolbar} cursor-pointer justify-start text-white `}
                onClick={(_) => setListActiveItem(null)}
              >
                <ChevronLeftIcon />
                <Typography>Back</Typography>
              </div>
              <Divider className="mx-4 bg-gray-700" />
              {listActiveItem.map(({ text, link, child, icon }, index) => (
                <ListLink
                  className={classes.listHover}
                  text={text}
                  key={index}
                  link={link}
                  child={child}
                  setListActiveItem={setListActiveItem}
                  icon={icon}
                  open={open}
                />
              ))}
            </>
          )}
        </div>
      </Drawer>
      </div>

      <div className="mobile_drawer">
          {
            openMobileDrawer ? 
            <>
            {renderClearIcon()}
            </>
            :
            <div className="menu_mobile_icon">
              <img
                    src={MenuIcon}
                    alt="Menu Icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setMobileDrawer(true);
                    }}
                    style={{background:'#430B9C'}}
                  />
            </div>
          }
      </div>
      
      <main className={`${classes.content} ${open ? 'with_Sidebar' : 'without_Sidebar'}`}>
        <div className={`${classes.toolbar} height_header`} />
        {WithQueryParams({ children, props, open })}
      </main>
    </div>
  );
};

export default (WrappedComponent, SidebarIconRoute) => {
  const hocComponent = ({ ...props }) => (
    <SideBar {...props} Allowed_Routes={SidebarIconRoute}>
      <WrappedComponent {...props} />
    </SideBar>
  );

  hocComponent.propTypes = {};

  return hocComponent;
};
//
